import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const AddZone = () => {
    const navigate = useNavigate()
    const [zoneName, setZoneName] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)

    const addZoneClick = () => {
        setLoading(true)
        const getMRObj = {
            // method: "add_zone",
            zone_name: zoneName,
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}add_zone`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setLoading(false)
                        toast.success("zone added successfully", {
                            position: "top-center",
                        });
                        navigate(-1)
                    }
                    else {
                        setLoading(false)
                        toast.success("Action failed !!", {
                            position: "top-center",
                        });
                    }
                });
            }).catch(() => setLoading(false))
    }

    return (
        <div className='h-100 w-full d-flex justify-content-center align-items-center ' >
            <div className='h-50 w-50 d-flex justify-content-center align-items-center' style={{ backgroundColor: ' #ffff', borderRadius: '8px' }} >
                <div className='d-flex flex-column w-75 justify-content-between' >
                    <div className=' d-flex justify-content-evenly align-items-center' >
                        <label className='form-label fs-6 fw-bolder text-dark' style={{ fontFamily: 'Poppins' }} >Zone Name</label>
                        <input className='search-input'
                            onChange={(e) => setZoneName(e?.target?.value)}
                            placeholder=' Zone Name '
                            style={{ outline: 'none', width: '300px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                    </div>
                    <div className='p-10 d-flex justify-content-evenly align-items-center'>
                        <button onClick={() => navigate(-1)} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: '80px', height: 'max-content' }} >Cancel</button>
                        <button disabled={zoneName === ""} onClick={() => addZoneClick()} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: '80px', height: 'max-content' }} >
                            {!loading && <span className='indicator-label'>Add</span>}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddZone